import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
  },
  connectionTitile: {
    fontSize: "22px",
    fontFamily: "Roboto",
    color: "#091E42",
  },
  rowContainer: {
    width: "100%",
    height: 48,
    border: "1px solid #D4DDE4",
    paddingLeft: 30,
    paddingRight: 30,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 720px)": {
      height: "auto",
      flexDirection: "column",
      paddingBottom: 15,
    },
  },

  row1: {
    width: "40%",
    "@media (max-width: 720px)": {
      width: "100%",
    },
  },
  boldText: {
    fontFamily: "Roboto-Medium",
    fontSize: 16,
    color: "#091E42",
  },
  row2: {
    width: "40%",
    "@media (max-width: 720px)": {
      width: "100%",
    },
  },
  normalText: {
    fontFamily: "Roboto",
    fontSize: 16,
    color: "#5B6773",
  },
  row3: {
    width: "20%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "@media (max-width: 720px)": {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  downText: {
    fontFamily: "Roboto",
    fontSize: 16,
    marginRight: 11,
  },

  table2Row1: {
    width: "30%",
    "@media (max-width: 720px)": {
      width: "100%",
    },
  },
  table2Row2: {
    width: "45%",
    "@media (max-width: 720px)": {
      width: "100%",
    },
  },
  table2Row3: {
    width: "25%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "@media (max-width: 720px)": {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  rowContainer2: {
    width: "100%",
    height: 94,
    border: "1px solid #D4DDE4",
    paddingLeft: 30,
    paddingRight: 30,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 720px)": {
      height: "auto",
      flexDirection: "column",
      paddingBottom: 15,
    },
  },
  table2Container: {
    marginTop: 40,
  },
  button: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #D4DDE4",
    width: 198,
    height: 42,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Roboto",
    fontWeight: 600,
    color: "#5B6773",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centerButton: {
    backgroundColor: "rgba(130, 78, 210, 0.16)",
    width: 131,
    height: 34,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#824ED2",
    borderRadius: 35,
    fontSize: 14,
    fontFamily: "Roboto",
    marginBottom: 15,
  },
  leftIconContainer: {
    display: "flex",
    alignItems: "center",
  },
  leftIcon: {
    marginLeft: 30,
  },
  switcButton: {
    width: 198,
    height: 42,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 720px)": {
      width: "100%",
      justifyContent: "flex-start",
    },
  },
  configContainer: {
    width: "100%",
    height: 380,
    border: "1px solid #D4DDE4",
    borderRadius: 12,
    marginTop: 40,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 720px)": {
      flexDirection: "column",
      // paddingLeft:30,
      height: "auto",
    },
  },
  leftRow: {
    width: "20%",
    paddingLeft: 30,
    "@media (max-width: 720px)": {
      width: "100%",
    },
  },
  leftRowText: {
    color: "#091E42",
    fontSize: 16,
    fontFamily: "Roboto-Medium",
  },
  rightRow: {
    width: "75%",
    paddingRight: 60,
    borderRadius: 6,
    "@media (max-width: 720px)": {
      width: "100%",
      paddingLeft: 30,
    },
  },
  infoContainer: {
    width: "100%",
    height: 92,
    backgroundColor: "rgba(3, 169, 244, 0.07)",
    border: "1px solid #00B9FF",
    display: "flex",
    "@media (max-width: 1100px)": {
      height: "auto",
    },
  },
  infoIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 92,
    // height: "100%",
    borderRight: "1px solid #00B9FF",
  },
  info: {
    color: "#091E42",
    fontSize: 16,
    fontFamily: "Roboto-SemiBold",
    marginLeft: 30,
  },
  infoHeading: {
    color: "#5B6773",
    fontSize: 16,
    fontFamily: "Roboto",
    marginLeft: 30,
  },
  kafkaContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 25,
  },
  kafkaTitle: {
    color: "#091E42",
    fontSize: 16,
    fontFamily: "Roboto-SemiBold",
    padding: 0,
    margin: 0,
    "@media (max-width: 360px)": {
      fontSize: 11,
      wordWrap: "break-word",
    },
  },
  kafkaIcon: {
    marginLeft: 10,
  },
  kafkaSwitcButton: {
    marginLeft: 10,
  },
  addText: {
    color: "#824ED2",
    fontSize: 16,
    fontFamily: "Roboto-SemiBold",
  },
  addIcon: {
    fontSize: 18,
    marginRight: 5,
  },
}));
